var map = {
	"./en.json": [
		"./src/locales/en.json",
		"src_locales_en_json"
	],
	"./languages.json": [
		"./src/locales/languages.json",
		"src_locales_languages_json"
	],
	"./pl.json": [
		"./src/locales/pl.json",
		"src_locales_pl_json"
	],
	"./timezones.json": [
		"./src/locales/timezones.json",
		"src_locales_timezones_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/locales lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;